module.exports = "/virtual-football-league/img/amblems/left/logos/TottenhamHotspur.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/TottenhamHotspur.png
// module id = 2128
// module chunks = 4